import { render } from "./NotificationButton.vue?vue&type=template&id=2450ba3c"
import script from "./NotificationButton.vue?vue&type=script&lang=js"
export * from "./NotificationButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__